 <template>
	<div class="record">
		<div class="container">
			<div class="flex">
				<div class="title" @mouseenter="enter" @mouseleave="leave">
					会话记录
					<!-- <i class="el-icon-warning"></i> -->
					<!-- <div  :class="classes">
          <p><span>访客进入时间</span>访客被分配到客服的时间</p>
          <p><span>访客首条消息时间</span>会话开始后访客发出的首条消息的时间</p>
          <p><span>客服首次响应时长</span>访客首条消息与客服回复消息的时间间隔</p>
          <p><span>访客排队时长</span>会话开始和访客进线的时间间隔</p>
          <p><span>溢出来源</span>被溢出会话原本应接待的客服组</p>
          <p><span>溢出原因</span>最终导致会话溢出的溢出规则名</p>
          <p><span>名溢出条件</span>最终导致会话溢出的溢出条件</p>
          <p><span>置顶时长</span>统计每通会话，客服触发置顶到结束置顶的时间</p>
          <p><span>重复咨询</span>开启重复咨询识别后，设定时间内访客来访的次数</p>
          <p><span>会话时长</span>会话开始到结束的时间间隔</p>

          <p><span>分配入口</span>访客分配"中配置的多入口，访客选择的入口名称</p>
          <p><span>用户解决状态</span>用户在满意度评价时选择的解决状态</p>
					</div>-->
				</div>
			</div>
			<div class="flex">
				<el-form
					:inline="true"
					v-model="sessionRrecordRequest"
					class="demo-form-inline"
				>
					<el-form-item label="会话Id">
						<el-input
							placeholder="会话Id"
							v-model.number="sessionRrecordRequest.accessChatId"
						></el-input>
					</el-form-item>
					<el-form-item label="用户名">
						<el-input
							placeholder="用户名"
							v-model="sessionRrecordRequest.consultName"
						></el-input>
					</el-form-item>
					<el-form-item label="手机号">
						<el-input
							placeholder="手机号"
							v-model="sessionRrecordRequest.mobile"
						></el-input>
					</el-form-item>
					<el-form-item label="客服">
						<el-select
							multiple
							collapse-tags
							v-model="sessionRrecordRequest.conversationIds"
						>
							<el-option
								key="-1"
								value="-1"
								label="全部客服"
							></el-option>
							<el-option
								v-for="item in userList"
								:key="item.conversationId"
								:value="item.conversationId"
								:label="item.nickName"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="渠道">
						<el-select v-model="sessionRrecordRequest.channelId">
							<el-option
								:key="-1"
								:value="-1"
								label="全部渠道"
							></el-option>
							<el-option
								:label="item.name"
								:value="item.id"
								:key="item.id"
								v-for="item in channelEnumList"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="状态">
						<el-select v-model="sessionRrecordRequest.state">
							<el-option
								:label="item.stateName"
								:value="item.state"
								:key="item.state"
								v-for="item in sessionState"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="会话开始时间">
						<el-date-picker
							v-model="value2"
							type="datetimerange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							:picker-options="pickerOptions"
							value-format="yyyy-MM-dd HH:mm:ss"
						></el-date-picker>
					</el-form-item>
					<el-form-item label="评价">
						<el-select v-model="sessionRrecordRequest.commentId">
							<el-option
								:key="-2"
								:value="-2"
								label="全部状态"
							></el-option>
							<el-option
								:key="-1"
								:value="-1"
								label="未评论"
							></el-option>
							<el-option
								:label="item.name"
								:value="item.id"
								:key="item.id"
								v-for="item in commentBase"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="联络原因">
						<div style="margin-top:5px">
							<consultationTypeTree :currentNodeKey="currentNodeKey"  @onSelectedId="onSelectedId" />
						</div>
					</el-form-item>
					<el-form-item label="产品名称">
						<div style="margin-top:5px">
							<productTree :currentNodeKey="currentNodeKeyProduct" @onSelectedId="onSelectedProductId"/>
						</div>
					</el-form-item>
					<el-form-item label="联系规格" prop="contactSpecificationsId">
						<el-select v-model="sessionRrecordRequest.contactSpecificationsId"  placeholder="请选择">
							<el-option
							:key="0"
							label="全部"
							:value="0">
							</el-option>
							<el-option
							v-for="item in contactSpecificationsList"
							:key="item.id"
							:label="item.name"
							:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="危机程度" prop="crisisId">
						<el-select v-model="sessionRrecordRequest.crisisId"  placeholder="请选择">
							<el-option :key="0" label="全部" :value="0"></el-option>
							<el-option
							v-for="item in crisisList"
							:key="item.id"
							:label="item.crisisName"
							:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="getAll"
							>查询</el-button
						>
						<el-tooltip
							content="可根据查询条件导出数据"
							placement="top"
						>
							<el-button type="primary" @click="exportSession"
								>导出数据</el-button
							>
						</el-tooltip>
					</el-form-item>
				</el-form>
			</div>
			<div class="table_box">
				<div>
					<!-- <ul class="state-ul">
						<li
							v-for="item in sessionState"
							@click="sessionClick(item)"
							:class="sessionRrecordRequest.state==item.state?'active':''"
						>{{item.stateName}}({{item.count}})</li>
					</ul>-->
				</div>
				<!-- @row-click="rowClick" -->
				<el-table
					v-loading="loading"
					:data="tableData"
					style="width: 100%"
					@row-click="rowClick"
					:default-sort="{ prop: 'date', order: 'descending' }"
				>
					<el-table-column
						prop="accessChatId"
						label="会话ID"
					></el-table-column>
					<el-table-column
						prop="entryTime"
						label="访客进入时间"
						width="140"
					></el-table-column>
					<el-table-column
						prop="kfNickName"
						label="接待客服"
						width="120"
					></el-table-column>
					<el-table-column
						prop="consultName"
						label="用户名"
						width="100"
					></el-table-column>
					<el-table-column
						prop="mobile"
						label="手机号码"
						width="120"
					></el-table-column>
					<el-table-column
						prop="startTime"
						label="会话开始时间"
						width="150px"
					></el-table-column>
					<el-table-column
						prop="endTime"
						label="会话结束时间"
						width="150px"
					></el-table-column>
					<el-table-column
						prop="commentName"
						label="评价"
					></el-table-column>
					<!-- <el-table-column prop="awaitDurationTime" label="排队等待时长"></el-table-column>
					<el-table-column prop="conversationDurationTime" label="会话时长"></el-table-column>-->
					<el-table-column
						prop="typeName"
						label="联络原因"
					>
					   <template slot-scope="scope">
							 <el-tooltip class="item" effect="dark" :content="scope.row.typeNameTree" placement="top-start">
								 <div> {{scope.row.typeName}}</div>
							</el-tooltip>
						</template>
					</el-table-column>
					<el-table-column
						prop="productName"
						label="产品名称"
					>
					   <template slot-scope="scope">
							 <el-tooltip class="item" effect="dark" :content="scope.row.productNameTree" placement="top-start">
								 <div> {{scope.row.productName}}</div>
							</el-tooltip>
						</template>
					</el-table-column>
					<el-table-column prop="contactSpecificationsName" label="联系规格"></el-table-column>
					<el-table-column prop="crisisName" label="危机程度"></el-table-column>
					<el-table-column
						prop="stateName"
						label="解决状态"
					></el-table-column>
					<el-table-column
						prop="endPople"
						label="会话终止方"
					></el-table-column>
					<el-table-column
						prop="channelName"
						label="来源渠道"
					></el-table-column>
				</el-table>
			</div>
			<div class="pagination">
				<!-- <el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-sizes="[10, 20, 30, 50]"
					:page-size="sessionRrecordRequest.pagination.pageSize"
					layout="sizes, prev, pager, next"
					:total="sessionRrecordRequest.pagination.total"
				></el-pagination>-->

				<el-pagination
					@current-change="handleCurrentChange"
					background
					:page-size="sessionRrecordRequest.pagination.pageSize"
					layout="total, prev, pager, next"
					:total="sessionRrecordRequest.pagination.total"
				></el-pagination>
			</div>
		</div>
		<div class="aside" v-if="drawerShow" v-loading="userInfoLoading">
			<div class="reply">
				<div class="flex-title">
					快捷回复
					<div>会话ID：{{ accessChatId }}</div>
					<el-button @click="tagResolved">标记已解决</el-button>
				</div>
				<div class="talk">
					<div class="containerChatRoom" id="testDiv">
						<p v-if="chatBoxLoading">{{ loadingText }}</p>
						<div
							:class="
								item.dialogues[0].sender == 2
									? 'talk_right'
									: 'talk_left'
							"
							v-for="(item, index) in dialogues"
							:key="index"
						>
							<div
								class="content"
								v-if="item.dialogues[0].sender === 2"
							>
								<div class="text">
									<span
										:key="index"
										v-for="(items, index) in item.dialogues"
									>
										<img
											v-if="items.messageType === 2"
											:src="items.content"
										/>
										<video
											style="width: 150px"
											controls="controls"
											v-else-if="items.messageType == 3"
											:src="items.content"
										></video>
										<span v-else>{{ items.content }}</span>
									</span>
								</div>
								<div class="creatime">
									{{ formatTime(item.sendTime) }}
								</div>
							</div>
							<div
								class="heading"
								v-if="item.dialogues[0].sender == 2"
							>
								<img :src="defaultKfHeadimg" />
							</div>
							<div
								class="heading"
								v-if="item.dialogues[0].sender == 1"
							>
								<img :src="consultHeadImg" />
							</div>

							<div
								class="content"
								v-if="item.dialogues[0].sender == 1"
							>
								<div class="text">
									<span
										:key="index"
										v-for="(items, index) in item.dialogues"
									>
										<img
											v-if="items.messageType === 2"
											:src="items.content"
										/>
										<video
											style="width: 150px"
											controls="controls"
											v-else-if="items.messageType == 3"
											:src="items.content"
										></video>
										<span v-else>{{ items.content }}</span>
									</span>
								</div>
								<div class="creatime">
									{{ formatTime(item.sendTime) }}
								</div>
							</div>
						</div>
						<!-- <div class="talk_right">
							<div class="content">
								<div class="text">以上为历史消息记录以上为历史消息记录</div>
							</div>
							<div class="heading">
								<img src="../../../assets/heading.png" />
							</div>
						</div>-->
					</div>
				</div>
				<!-- <div class="remind">
					剩余提醒次数{{remainingReminders}}
					<span style="float:right">
						<el-tooltip class="item" effect="dark" content="发送模板消息提醒用户" placement="right-start">
							<el-button
								icon="el-icon-thumb"
								type="primary"
								size="mini"
								circle
								:disabled="remainingReminders==0"
								@click="sendRemind"
							></el-button>
						</el-tooltip>
					</span>
				</div>-->
				<textarea
					id="charInput"
					v-model="replyMessage"
					class="charInput"
					placeholder="请输入文字按回车(Enter)键发送"
					@keyup.enter="sendMessage"
				></textarea>
			</div>
			<userinfor
				:addressList="addressList"
				:currentUserInfo="currentUserInfo"
				:consultationTypes="consultationTypes"
				:accessChatId="accessChatId"
				:channelName="channelName"
				:openid="consultId"
				@onLoading="
					(val) => {
						userInfoLoading = val
					}
				"
				@updUserInfo="updUserInfo"
				@saveCustomerCenter="saveCustomerCenter"
			/>
			<a class="close" @click="close">x</a>
		</div>
	</div>
</template>

<script>
import userinfor from '@/components/customer/talks/userInfo'
import consultationTypeTree from '../../customer/talks/consultationTypeTree';
import productTree from '../../customer/talks/productTree.vue';
import { DateTime } from '@/utils/common'
import { FormatTimes } from '@/utils/FormatTime'
export default {
	name: 'Record_the_session',
	props: [],
	data() {
		return {
			classes: 'flex-dialog',
			input1: '',
			value2: [],
			tableData: [],
			loading: false,
			sessionRrecordRequest: {
				key: 'consultName',
				value: '',
				state: -2,
				startTime: null,
				endTime: null,
				mobile: '',
				channelId: -1,
				conversationIds: [],
				commentId: -2,
				consultationTypeId: -1,
				crisisId:0,
				contactSpecificationsId:0,
				pagination: {
					pageIndex: 1,
					pageSize: 20,
					total: 20,
				},
			},
			pickerOptions: {
				disabledDate(date) {
					return date.getTime() >= Date.now()
				},
				shortcuts: [
					{
						text: '最近一周',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(
								start.getTime() - 3600 * 1000 * 24 * 7
							)
							picker.$emit('pick', [start, end])
						},
					},
					{
						text: '最近一个月',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(
								start.getTime() - 3600 * 1000 * 24 * 30
							)
							picker.$emit('pick', [start, end])
						},
					},
					{
						text: '最近三个月',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(
								start.getTime() - 3600 * 1000 * 24 * 90
							)
							picker.$emit('pick', [start, end])
						},
					},
				],
			},
			dropArray: [
				{
					key: 'accessChatId',
					val: '会话Id',
				},
				{
					key: 'consultName',
					val: '用户名',
				},
			],
			selectedName: '用户名',
			sessionState: [],
			drawerShow: false,
			userInfoLoading: false,
			addressList: [],
			currentUserInfo: {},
			chatBoxLoading: false,
			dialogues: [],
			replyMessage: '',
			accessChatId: 0,
			consultId: '',
			defaultKfHeadimg: '',
			consultHeadImg: '',
			consultationTypes: [],
			remainingReminders: 1,
			channelName: '',
			channelEnumList: [],
			userList: [],
			commentBase: [],
			currentNodeKey:[],
			currentNodeKeyProduct:[],
			contactSpecificationsList:[],
			crisisList:[]
		}
	},
	watch: {
		value2: function (val) {
			if (val) {
				this.sessionRrecordRequest.startTime = val[0].replace(' ', 'T')
				this.sessionRrecordRequest.endTime = val[1].replace(' ', 'T')
			} else {
				this.sessionRrecordRequest.startTime = null
				this.sessionRrecordRequest.endTime = null
			}
		},
		dialogues: function () {
			setTimeout(function () {
				var ele = document.getElementById('testDiv')
				ele.scrollTop = ele.scrollHeight
			}, 50)
		},
	},
	props: {
		initData: {
			type: Object,
			default: {},
		},
	},
	mounted: function () {},
	created: function () {
		let vm = this
		this.getAddress()
		this.getConsultationTypes()
		this.getChannelList()
		this.getUserList()
		this.getCommentBase()
		this.getContactSpecifications();
		this.getCrisisEnum();
		if (Object.keys(vm.initData).length > 0) {
			if (vm.initData.type == 'channel') {
				vm.sessionRrecordRequest.channelId = vm.initData.channelId
			} else if (vm.initData.type == 'state') {
				vm.sessionRrecordRequest.state = vm.initData.state
			} else if (vm.initData.type == 'comment') {
				vm.sessionRrecordRequest.commentId = vm.initData.commentId
			} else if (vm.initData.type == 'conType') {
				vm.sessionRrecordRequest.consultationTypeId = vm.initData.typeId
			}
			vm.sessionRrecordRequest.startTime = vm.initData.startTime
			vm.sessionRrecordRequest.endTime = vm.initData.endTime
			vm.value2.push(vm.initData.startTime.replace('T', ' '))
			vm.value2.push(vm.initData.endTime.replace('T', ' '))
			vm.$emit('clareInitData')
		}
		this.getAll()

		this.defaultKfHeadimg = localStorage.getItem('defaultKfHeadimg')
		this.consultHeadImg = localStorage.getItem('defaultConsultHeadimg')
	},
	methods: {
		enter() {
			this.classes = 'flex-dialog on'
		},
		leave() {
			this.classes = 'flex-dialog'
		},
		formatTime(time) {
			let date = new DateTime()
			if (date.getDate() === FormatTimes(time, 'yyyy-MM-dd')) {
				return '今天' + FormatTimes(time, 'hh:mm:ss')
			}
			return FormatTimes(time, 'yyyy-MM-dd hh:mm:ss')
		},
		print(item) {
			return '1'
		},
		getAll() {
			let vm = this
			vm.loading = true
			this.axios
				.all([this.getSessionRecord(), this.getSessionStateCount()])
				.then(function (data1) {
					var sessionRecord = data1[0]
					var sessionStateCount = data1[1]
					if (sessionRecord.data.result) {
						vm.sessionRrecordRequest.pagination =
							sessionRecord.data.data.pagination
						vm.tableData = sessionRecord.data.data.list
					}
					if (sessionStateCount.data.result) {
						vm.sessionState = sessionStateCount.data.data
					}
					vm.loading = false
				})
		},
		getSessionRecord() {
			let vm = this
			return this.axios.post(
				'AccessChat/GetAccessLog_Li',
				vm.sessionRrecordRequest
			)
		},

		getSessionStateCount() {
			let vm = this
			return this.axios.post(
				'AccessChat/GetSessionStateCount_Li',
				vm.sessionRrecordRequest
			)
		},
		handleSizeChange(val) {
			this.sessionRrecordRequest.pagination.pageSize = val
			this.getAll()
		},
		handleCurrentChange(val) {
			this.sessionRrecordRequest.pagination.pageIndex = val
			this.getAll()
		},
		currentPage2(val) {},
		dropCommand(val) {
			let vm = this
			let obj = vm.dropArray.find((d) => d.key == val)
			vm.sessionRrecordRequest.key = val
			vm.selectedName = obj.val
		},
		sessionClick(state) {
			let vm = this
			vm.sessionRrecordRequest.state = state.state
			vm.getAll()
		},
		updUserInfo(val) {
			let vm = this
			this.axios
				.post('ConsultantInfo/updUserInfo', val)
				.then(function ({ data }) {
					if (!data.result) {
						vm.$notify.error({
							title: '错误',
							message: data.message,
						})
					}
				})
		},
		saveCustomerCenter(val) {
			let vm = this
			val.accessChatId = vm.accessChatId
			this.axios
				.post('AccessChat_Subtotal', val)
				.then(function ({ data }) {
					if (!data.result) {
						vm.$notify.error({
							title: '错误',
							message: data.message,
						})
					} else {
						vm.getAll()
						vm.$message({ type: 'success', message: '保存成功' })
					}
				})
		},
		close() {
			this.drawerShow = false
		},
		sendMessage() {
			let date = new DateTime()
			let str = date.Now()
			let vm = this
			let send = new Object()
			var array = []
			var obj = new Object()
			obj.consultId = vm.consultId
			obj.sender = 2
			obj.content = vm.replyMessage.replace('\n', '')
			obj.messageType = 1
			obj.accessChatId = vm.accessChatId
			array.push(obj)
			send.Receiver = vm.consultId
			send.dialogues = array
			send.sendTime = str
			vm.replyMessage = ''
			vm.dialogues.push(send)
			let endObj = { ...send }
			this.$delete(endObj, 'sendTime')
			this.axios
				.post('SendMessage/ReplyMessage', endObj)
				.then(function ({ data }) {})
		},
		rowClick(val) {
			this.accessChatId = val.accessChatId
			this.drawerShow = true
			this.channelName = val.channelName
			this.consultId = val.consultId
			this.getUserInfo(val.consultId, val.accessChatId)
			this.getDialogues()
		},
		getDialogues() {
			let vm = this
			this.axios
				.get('Dialogue/getDia', {
					params: { accessChatId: vm.accessChatId },
				})
				.then(function ({ data }) {
					if (data.result) {
						vm.dialogues = data.data
					}
				})
		},
		getUserInfo(openid, accessChatId) {
			let vm = this
			// vm.userInfoLoading = true
			if (openid == '' || accessChatId == 0) {
				return
			}
			this.axios
				.get('ConsultantInfo/getUserInfo', {
					params: { openid: openid, accessChatId: accessChatId },
				})
				.then(function ({ data }) {
					if (data.result) {
						vm.currentUserInfo = data.data
					} else {
						vm.$notify.error({
							title: '错误',
							message: data.message,
						})
					}
					// vm.userInfoLoading = false
				})
		},
		getAddress() {
			let vm = this
			this.axios.get('Address/GetAdd').then(function ({ data }) {
				if (data.result) {
					vm.addressList = data.data
				}
			})
		},
		getConsultationTypes() {
			let vm = this
			this.axios
				.get('ConsultationTypes/getConsultTypes')
				.then(function ({ data }) {
					if (data.result) {
						vm.consultationTypes = data.data
					}
				})
		},
		tagResolved() {
			let vm = this
			this.axios
				.get('AccessChat_Subtotal/updState', {
					params: {
						accessChatId: vm.accessChatId,
					},
				})
				.then(function ({ data }) {
					if (data.result) {
						vm.$message({ type: 'success', message: '标记成功' })
						vm.getAll()
					}
				})
		},
		getRemind() {
			//获取提醒次数
			let vm = this
			this.axios.get(
				'SubscriptionRecord/FetchAvailableCount',
				{ params: { consultId: vm.consultId } },
				function ({ data }) {
					if (data.result) {
						vm.remainingReminders = data.data
					}
				}
			)
		},
		sendRemind() {
			let vm = this
			this.axios
				.get('SendTemplate/SendRemind', {
					params: {
						consultId: vm.consultId,
					},
				})
				.then(function ({ data }) {
					if (data.result) {
						vm.remainingReminders = vm.remainingReminders - 1
						vm.$message({ type: 'success', message: '提醒成功' })
					}
				})
		},
		exportSession() {
			let vm = this
			this.axios
				.post('AccessChat/ExportSession_Li', vm.sessionRrecordRequest, {
					responseType: 'blob',
				})
				.then(function (res) {
					let filename = '会话记录.xls'
					let blob = res.data
					let reader = new FileReader()
					reader.readAsDataURL(blob)
					reader.onload = (e) => {
						//创建a标签，插入到文档中并click，最后移除
						let a = document.createElement('a')
						a.download = filename
						a.href = e.target.result
						document.body.appendChild(a)
						a.click()
						document.body.removeChild(a)
					}
				})
		},
		getChannelList() {
			let vm = this
			this.axios
				.get('MiniChannelEnum/SelectList')
				.then(function ({ data }) {
					vm.channelEnumList = data
				})
		},
		getUserList() {
			let vm = this
			this.axios
				.post('CustomerMessage/getAllFollowUp')
				.then(function ({ data }) {
					vm.userList = data
				})
		},
		getCommentBase() {
			let vm = this
			this.axios.get('Comment/GetComments').then(function ({ data }) {
				vm.commentBase = data
			})
		},
		onSelectedId(val){
			this.currentNodeKey=val;
			if(val.length==0){
				this.sessionRrecordRequest.ConsultationTypeId=-1;
			}else{
				this.sessionRrecordRequest.ConsultationTypeId=val[0];
			}
		},
		onSelectedProductId(val){
			this.currentNodeKeyProduct=val;
			if(val.length==0){
				this.sessionRrecordRequest.productId=-1;
			}else{
				this.sessionRrecordRequest.productId=val[0];
			}
		},
		getContactSpecifications(){
			let vm =this;
			
			this.axios.get('/ContactSpecifications').then(function({data}){
				vm.contactSpecificationsList=data.data
			})
		},
		getCrisisEnum(){

			let vm =this;
			
			this.axios.get('/CrisisEnum').then(function({data}){
				vm.crisisList=data.data
			})
		}
	},
	components: {
		userinfor,
		consultationTypeTree,
		productTree
	},
}
</script>

<style scoped>
.system .flex {
	padding: 30px 0 10px 0;
}
.system .title {
	font-size: 16px;
	font-weight: bold;
	float: left;
	line-height: 32px;
	margin-right: 30px;
	position: relative;
}
.close {
	display: block;
	position: absolute;
	width: 30px;
	height: 30px;
	line-height: 28px;
	text-align: center;
	background-color: #fff;
	left: -30px;
	top: 20px;
	font-size: 16px;
	color: #999;
	box-shadow: -2px -1px 2px 1px rgba(0, 0, 0, 0.1);
}
.container {
	/* padding: 0px 45px; */
	height: 100%;
	padding-right: 15px;
}
.containerChatRoom {
	padding: 0px 30px;
}
.flex {
	padding: 30px 25px 10px 0;
}
.title {
	font-size: 22px;
	float: left;
}
.search {
	float: left;
	margin-left: 30px;
}
.search_box {
	float: left;
}
.dropmenu {
	float: left;
}
.dropmenu button {
	border-radius: 4px 0 0 4px !important;
	border-right: none;
}
.date_box {
	float: left;
	margin-left: 20px;
}
.date {
	width: 140px;
}
.export {
	float: right;
}
.el-button.export {
	background-color: #409eff;
	color: #fff;
}
.table_box {
	margin-top: 40px;
}
.pagination {
	text-align: right;
}
.el-pagination {
	text-align: right;
	margin-top: 50px;
	display: inline-block;
}
/* .el-button {
	background-color: #fafafa;
} */
.state-ul li {
	display: inline-block;
	padding: 3px 10px;
}
.state-ul li:hover {
	cursor: pointer;
	text-decoration: underline;
}
.state-ul li.active {
	text-decoration: underline;
	color: #409eff;
}
/*侧边弹窗*/
.aside {
	position: fixed;
	top: 62px;
	right: 0;
	height: 100%;
	width: 740px;
	background-color: #fff;
	z-index: 1000;
	box-shadow: -4px -1px 4px 1px rgba(0, 0, 0, 0.1);
}
/*留言详情*/
.reply {
	width: 50%;
	display: inline-block;
	float: left;
	border-right: 1px solid #ddd;
	box-sizing: border-box;
	height: 100%;
}
.flex-title {
	display: -webkit-flex; /*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 42px;
	line-height: 42px;
	border-bottom: 1px solid #ddd;
	padding: 0 15px;
}
.talk {
	padding: 30px 0px 10px 0;
	height: 60%;
	border-bottom: 1px solid #ddd;
	overflow-y: auto;
	overflow-x: hidden;
}
.search-box {
	line-height: 44px;
	border-bottom: 1px solid #ddd;
}
.search-box .el-input-group {
	width: 320px;
}
.talk p {
	text-align: center;
	color: #bbb;
	line-height: 30px;
}
.container {
	overflow-x: hidden;
	overflow-y: auto;
}
.charInput {
	display: block;
	width: 300px;
	padding: 5px 15px;
	min-height: 120px;
	max-height: 120px;
	outline: none;
	font-size: 14px;
	line-height: 30px;
	word-wrap: break-word;
	margin: 10px auto 0;
	background-color: #f1f1f1;
	border: 1px solid #ddd;
	resize: none;
}
.remind {
	margin: 10px auto 0;
	width: 330px;
	line-height: 25px;
}
.creatime {
	color: #999;
	padding: 5px 10px 5px 50px;
	margin-bottom: 10px;
}
/*滚动条样式*/
::-webkit-scrollbar {
	width: 4px;
}

::-webkit-scrollbar-track {
	border-radius: 5px;
}

::-webkit-scrollbar-thumb {
	background-color: #d6d6d6;
	border-radius: 5px;
}

.talk_left {
	display: -webkit-flex; /*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	margin-bottom: 10px;
	min-width: 100px;
}
.talk_left .content {
	margin-left: 10px;
}
.talk_left .content img {
	max-width: 195px;
}
.text {
	max-width: 195px;
	padding: 15px;
	background-color: #dcedf9;
	border-radius: 5px;
	font-size: 14px;
	letter-spacing: 1px;
	word-wrap: break-word;
	word-break: normal;
}
.text span {
	width: 100%;
}
.talk_left .text::after {
	position: absolute;
}
.talk_right {
	display: -webkit-flex; /*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: flex-end;
	align-items: flex-start;
	margin-bottom: 10px;
}
.talk_right .content {
	margin-right: 10px;
}
.talk_right .content img {
	max-width: 225px;
}
.heading {
	width: 40px;
	height: 40px;
	border-radius: 50%;
}
.heading img {
	width: 100%;
	height: 100%;
	border-radius: 50%;
}
/*用户信息*/

.message {
	padding: 0px 0 30px 30px;
	box-sizing: border-box;
}
.access {
	margin-top: 20px;
}
.option {
	display: -webkit-flex; /*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: flex-start;
	align-items: center;
}
.lablelist span {
	display: inline-block;
	margin: 15px 15px 5px 0;
	color: #666;
	min-width: 60px;
}
.lablelist span.special {
	vertical-align: top;
}
.iconfont {
	cursor: pointer;
}
.access textarea {
	resize: none;
	width: 100%;
	height: 50px;
	padding: 5px;
	line-height: 20px;
	outline: none;
}
.remark {
	resize: none;
	margin-top: 10px;
}
.save {
	float: right;
	margin: 10px 20px;
}

.f-right {
	float: right;
	cursor: pointer;
}
</style>
<style>
.el-table {
	color: #000;
}
.el-table thead {
	color: #000;
}
.record .aside .userinfor {
	width: 50%;
	display: inline-block;
	float: right;
}
.record .message {
	box-sizing: border-box;
	height: 100%;
	overflow: auto;
}
.search_box .el-input__inner {
	border-radius: 0 4px 4px 0;
}
.flex-dialog {
	display: none;
	position: absolute;
	width: 500px;
	padding: 30px;
	min-height: 100px;
	background-color: #fff;
	top: 25px;
	left: 64px;
	box-shadow: 0 0 4px #ddd;
	z-index: 1000;
}
.flex-dialog.on {
	display: block;
}
.flex-dialog p {
	white-space: nowrap;
	line-height: 28px;
	font-size: 14px;
	color: #333;
}
.flex-dialog p span {
	display: inline-block;
	width: 125px;
}
</style>




// WEBPACK FOOTER //
// src/components/manage/system/Record_the_session.vue